import React from 'react';
import styled from 'styled-components';
import Loading from 'shared/migration-components/loading';
import {useParams} from 'react-router-dom';
import Category from './components/category';
import useCategoriesByCompany from 'modules/categories/hooks/use-categories-by-company';
import {SemiBoldText} from 'shared/components/text';

const Page = styled.div`
  display: flex;
  flex: 1;
  background-color: white;
`;

const ScrollArea = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 0 25px;
  padding-top: 15px;
`;

const CompanyProducts: React.FC = () => {
  const {companyId} = useParams<{companyId: string}>();
  const categoriesQuery = useCategoriesByCompany(companyId);

  if (categoriesQuery.isLoading) return <Loading flex />;

  return (
    <Page>
      <ScrollArea>
        <SemiBoldText size="extra-large">Produtos</SemiBoldText>
        {(categoriesQuery.data ?? []).map((category) => (
          <Category key={category.id} {...category} />
        ))}
      </ScrollArea>
    </Page>
  );
};

export default CompanyProducts;
